import { Link } from 'react-router-dom';

const WHATSAPP_URL =
  'https://wa.me/5585982245030?text=Olá!%20Vim%20pelo%20site%20da%20Naturalle%20Sanduíches%20e%20gostaria%20de%20mais%20informações.';

const Footer = () => {
  return (
    <footer className="relative bg-background-100 pt-16 md:pt-20 pb-8 overflow-hidden">
      {/* Gold top hairline */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-secondary-500/50 to-transparent" />
      {/* Soft gold glow */}
      <div className="absolute top-[-160px] left-1/2 -translate-x-1/2 w-[600px] h-[320px] rounded-full bg-secondary-500/5 blur-3xl" />

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 mb-12 md:mb-16">
            {/* Brand */}
            <div className="lg:col-span-2 max-w-sm">
              <Link to="/" className="inline-flex items-baseline gap-2.5 mb-5">
                <span className="font-display text-3xl text-foreground-900">Naturalle</span>
                <span className="font-label text-[10px] tracking-[0.35em] uppercase text-secondary-500 mb-1">
                  Sanduíches
                </span>
              </Link>
              <p className="font-body text-sm text-foreground-500 leading-relaxed mb-6">
                Sanduíches naturais feitos à mão todos os dias em Fortaleza-CE. Ingredientes escolhidos a
                dedo, embalagem a vácuo e aquele sabor de comida de verdade que já faz parte da rotina dos
                cearenses há mais de 24 anos.
              </p>
              <div className="flex gap-3">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="w-10 h-10 rounded-full border border-secondary-500/30 flex items-center justify-center text-foreground-500 hover:border-secondary-500 hover:text-secondary-400 transition-all"
                >
                  <i className="ri-whatsapp-line" />
                </a>
                <a
                  href="https://www.instagram.com/naturallesanduiches/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="w-10 h-10 rounded-full border border-secondary-500/30 flex items-center justify-center text-foreground-500 hover:border-secondary-500 hover:text-secondary-400 transition-all"
                >
                  <i className="ri-instagram-line" />
                </a>
              </div>
            </div>

            {/* Links */}
            <div>
              <h4 className="font-label text-[11px] font-semibold tracking-[0.2em] uppercase text-secondary-500 mb-5">
                Navegação
              </h4>
              <ul className="space-y-3">
                {[
                  { label: 'Início', href: '#hero' },
                  { label: 'Produtos', href: '#produtos' },
                  { label: 'Qualidade', href: '#qualidade' },
                  { label: 'Revenda', href: '#revenda' },
                  { label: 'Cardápio', to: '/cardapio' },
                ].map((link) => (
                  <li key={link.label}>
                    {'to' in link ? (
                      <Link
                        to={link.to!}
                        className="font-body text-sm text-foreground-500 hover:text-secondary-400 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="font-body text-sm text-foreground-500 hover:text-secondary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-label text-[11px] font-semibold tracking-[0.2em] uppercase text-secondary-500 mb-5">
                Contato
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2.5">
                  <i className="ri-map-pin-2-line text-secondary-500 mt-0.5 text-sm" />
                  <span className="font-body text-sm text-foreground-500">
                    Rua Capitão Vasconcelos, 237<br />Alto da Balança, Fortaleza – CE
                  </span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="ri-whatsapp-line text-secondary-500 text-sm" />
                  <span className="font-body text-sm text-foreground-500">(85) 98224-5030</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="ri-time-line text-secondary-500 text-sm" />
                  <span className="font-body text-sm text-foreground-500">Seg–Sex: 06:30 às 16:30</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="pt-6 md:pt-8 border-t border-secondary-500/15 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="font-label text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} Naturalle Sanduíches. Todos os direitos reservados.
            </p>
            <p className="font-label text-xs text-foreground-400">Fortaleza – Ceará – Brasil</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;